import { computed } from 'vue'
import type { CommentsState } from './state'

export const createGetters = (state: CommentsState) => {
  const publicComments = computed(() =>
    state.comments.filter((c) => !c.isInternal)
  )

  const internalComments = computed(() =>
    state.comments.filter((c) => c.isInternal)
  )

  const commentsCount = computed(() => state.comments.length)

  const publicCommentsCount = computed(() =>
    state.comments.filter((c) => !c.isInternal).length
  )

  const internalCommentsCount = computed(() =>
    state.comments.filter((c) => c.isInternal).length
  )

  const sortedByNewest = computed(() =>
    [...state.comments].sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
  )

  const sortedByOldest = computed(() =>
    [...state.comments].sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime())
  )

  return {
    publicComments,
    internalComments,
    commentsCount,
    publicCommentsCount,
    internalCommentsCount,
    sortedByNewest,
    sortedByOldest,
  }
}
